<template>
    <div id="header-root" class="headerRoot">
        <div id="search-header" class="searchHeader">
            <div id="header-input-wrapper" class="headerInputWrapper">
                <div
                    id="header-logo"
                    class="headerLogo"
                    @click="goToHomepage()"
                >
                    <img
                        id="header-logo-img"
                        class="headerLogoImage"
                        :src="branding.logo"
                    />
                </div>
                <div
                    id="header-input-inner-wrapper"
                    class="headerInputInnerWrapper"
                >
                    <div
                        id="header-input-icon"
                        class="headerInputIconWrapper"
                        @click="goToSerpVertical()"
                    >
                        <i class="fa fa-search headerInputIcon"></i>
                    </div>
                    <input
                        id="header-input"
                        class="headerInput"
                        v-model="query"
                        @keydown.enter="goToSerpVertical()"
                    />
                </div>
            </div>
            <div id="header-nav" class="headerNav" v-show="!hideCat">
                <div
                    v-for="(navItem, index) in viewList"
                    :key="index"
                    :id="`nav_${navItem.name}`"
                    class="navItem"
                    :class="{ activeNavItem: isCurrentRoute(navItem.name) }"
                    @click="setCurrentMode(navItem)"
                >
                    <img
                        :id="`nav-icon_${navItem.name}`"
                        class="navIcon"
                        :src="navItem.icon"
                    />
                    <div :id="`nav-link_${navItem.name}`" class="navLink">
                        {{ navItem.name }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import queryString from "query-string";
import { documentReady, isMobile, openUrl } from "@/common";
import { verticalList, defaultVertical } from "@/linkLists";
import { pageviewEvent, searchEvent, clickEvent } from "@/analytics";
import { getBranding } from "@/branding";
import { YAHOO_COBRAND_URL } from "@/urls";

export default {
    name: "freshy-header",
    data() {
        const qs = queryString.parse(window.location.search);
        return {
            query: qs.q || null,
            typeTag: qs.type || null,
            guid: qs.guid || null,
            enteredQuery: qs.q || null,
            routerKey: 0,
            viewList: verticalList,
            branding: getBranding(),
            currentMode: defaultVertical,
            hideCat: false,
        };
    },

    mounted() {
        const mount_this = this;
        document.querySelector("#header-input").focus();
        // Possible pageview call here

        document.addEventListener(
            "scroll",
            e => {
                if (e.target && e.target.scrollTop == 0) {
                    mount_this.hideCat = false;
                } else {
                    mount_this.hideCat = true;
                }
            },
            true
        );
    },
    methods: {
        setCurrentMode(navItem) {
            this.currentMode = navItem;
        },
        isCurrentRoute(routeName) {
            return this.currentMode.name == routeName;
        },
        goToHomepage() {
            let params = "";
            if (window.location.search) {
                const searchParams = new URLSearchParams(
                    window.location.search
                );
                searchParams.delete("q");
                if (Array.from(searchParams).length > 0)
                    params = `?${searchParams.toString()}`;
            }
            window.location.href = `/${params}`;
        },
        goToSerpVertical() {
            if (this.query && this.currentMode.path) {
                const newUrl = `${this.currentMode.path}?q=${this.query}`;
                openUrl(newUrl);
            }
        },
    },
};
</script>

<style>
@import "./header.css";
</style>
